import React from 'react';

import AbstractMenuItem from '../abstract-menu-item';
import normalImage from './assets/normal-image.gif';
import hoverImage from './assets/hover-image.gif';
import activeImage from './assets/active-image.gif';

const CompanyMenu = () => {
  return (
    <AbstractMenuItem page='/company' name='会社概要' normalImage={normalImage} hoverImage={hoverImage} activeImage={activeImage} />
  );
};

export default CompanyMenu;
